// Module
var code = `<div class="svc-sidebar__header svc-sidebar__header--tabbed">
  <div class="svc-sidebar__header-container svc-sidebar__header-container--with-subtitle">
    <div class="svc-sidebar__header-content">
      <div data-bind="css: \$data.model.buttonClassName, 
      click: function(s, args) { \$data.model.action(\$data); }, key2click: { processEsc: false }">
        <div class="svc-sidebar__header-caption">
          <span class="svc-sidebar__header-title" data-bind="text: model.title"></span>
          <span class="svc-sidebar__header-subtitle" data-bind="text: model.tooltip"></span>
        </div>
      </div>
      <sv-popup params="{ model: model.popupModel }"></sv-popup>
    </div>
  </div>
</div>`;
// Exports
export default code;